import app from '../../store/mst';
import AnalyticsEvents from '../analyticsEvents';
import { AnalyticsEventsProps } from '../analyticsEventsProps';

export enum SCHEDULING_EVENT_ACTIONS {
  SCHEDULE_ALL = 'scheduleAll',
  SCHEDULING_REQUESTED = 'schedulingRequested',
}

export function trackScheduleAll() {
  const { account, workspaceOptimizationPreferencesForTracking } = app;

  account.trackUserForAnalytics(AnalyticsEvents.SCHEDULE_ALL, {
    workspaceOptimizationPreferences: workspaceOptimizationPreferencesForTracking ?? null,
  });
}

interface SchedulingOptions {
  orderSelection: AnalyticsEventsProps.Scheduling.OrderSelection,
  availableRoutesCount: number,
  reoptimize: boolean,
  source: AnalyticsEventsProps.Scheduling.Source,
  routeCount?: number,
  orderCount?: number,
}

export function trackSchedulingRequested(options: SchedulingOptions) {
  const { orderSelection, availableRoutesCount, reoptimize, source, routeCount = availableRoutesCount, orderCount } = options;
  const { account } = app;
  const namespace = AnalyticsEventsProps.Scheduling;

  let routeScenario;
  if (availableRoutesCount > 0) {
    routeScenario = routeCount < availableRoutesCount ? namespace.RouteScenario.SELECTION : namespace.RouteScenario.ALL;
  } else {
    routeScenario = namespace.RouteScenario.NONE;
  }

  const optimizationType = reoptimize ? namespace.OptimizationType.REOPTIMIZE : namespace.OptimizationType.INSERT;

  account.trackUserForAnalytics(AnalyticsEvents.SCHEDULING_REQUESTED, {
    orderSelection,
    orderSelectionCount: orderCount ?? null,
    routeScenarioCount: routeCount,
    routeScenario,
    optimizationType,
    source_page: source,
  });
}

export const schedulingTrackers = {
  [SCHEDULING_EVENT_ACTIONS.SCHEDULE_ALL]: trackScheduleAll,
  [SCHEDULING_EVENT_ACTIONS.SCHEDULING_REQUESTED]: trackSchedulingRequested,
};
